import React from "react";
import { useTranslation } from "react-i18next";

/**
 * SDA flow test mode.
 *
 * Enabled via `VITE_SDA_TEST_MODE=true` in `.env.development`.
 * Production builds should not set this env var.
 */
export const isSDATestMode = (): boolean =>
  import.meta.env.VITE_SDA_TEST_MODE === "true";

export const SDATestModeBanner: React.FC = () => {
  const { t } = useTranslation();
  if (!isSDATestMode()) return null;
  return (
    <div className="mb-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-xs font-medium text-amber-800">
      {t("sda.testMode.banner")}
    </div>
  );
};

interface SDATestSkipButtonProps {
  onSkip: () => void;
  label?: string;
}

export const SDATestSkipButton: React.FC<SDATestSkipButtonProps> = ({
  onSkip,
  label,
}) => {
  const { t } = useTranslation();
  if (!isSDATestMode()) return null;
  return (
    <button
      type="button"
      onClick={onSkip}
      className="rounded-lg border border-amber-400 px-4 py-2 text-sm font-medium text-amber-700 transition-colors hover:bg-amber-50 cursor-pointer"
    >
      {label ?? t("sda.testMode.skip")}
    </button>
  );
};
